export const toggleActiveClass = {
  methods: {
    setActiveClass(e) {
      const elem = e.currentTarget;
      this.removeActiveClass();
      setTimeout(() => {
        elem.classList.add('active');
      }, 1);
      elem.classList.add('show');
      elem.setAttribute('aria-expanded', true);
    },

    removeActiveClass() {
      this.$el.querySelectorAll('.mega-menu__brand-trigger.active').forEach(trigger => {
        trigger.classList.remove('active');
        setTimeout(() => {
          trigger.classList.remove('show');
        }, 500);
        trigger.setAttribute('aria-expanded', false);
      });
    }
  }
};
